module.exports = __webpack_public_path__ + "img/ChartBar.f94e9bcc.svg";